module.exports = __webpack_public_path__ + "static/c-JPina-9d0eed2e0d21c3d1378216b978dd407f.jpg";